import React from "react";

const EmptyMessage = () => {
  return "Aucune donnée disponible.";
};

export default EmptyMessage;
